import React from 'react';
import OverviewGoalsSection from './overview/OverviewGoalsSection';
import OverviewDestimeSection from './destime/OverviewDestimeSection';

const OverviewSection = ({ goalsProps, destimeProps }) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <OverviewGoalsSection {...goalsProps} />
      <OverviewDestimeSection {...destimeProps} />
    </div>
  );
};

export default OverviewSection;
